import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import * as Yup from 'yup';
import messages from '../constants/messages';
import { useTenantContext } from '../context/TenantContext';
import useCreateCustomerSchema from './useCreateCustomerSchema';

const useCreateDetailsSchema = () => {
    const { formatMessage } = useIntl();
    const { brandConfig } = useTenantContext();
    const createCustomerSchema = useCreateCustomerSchema();
    const mandatoryMessage = formatMessage(messages.fieldError);

    return useCallback(
        (deskOrder = false, deviceId = false) =>
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Yup.lazy((values: any) =>
                values.anonymously
                    ? Yup.object().nullable()
                    : deskOrder
                    ? Yup.object()
                          .nullable()
                          .shape({
                              customerInfo: createCustomerSchema(true),
                              agreedToTerms: Yup.bool().oneOf([true], formatMessage(messages.agreedToTermsError)),
                              birthdate: Yup.object()
                                  .minimumAge(
                                      brandConfig.minBookingAge,
                                      formatMessage(messages.minimumAgeError, { age: brandConfig.minBookingAge })
                                  )
                                  .shape({
                                      day: Yup.string(),
                                      month: Yup.string(),
                                      year: Yup.string(),
                                  })
                                  .nullable(),
                          })
                    : deviceId
                    ? Yup.object().shape({
                          customerInfo: createCustomerSchema(false, true),
                          agreedToTerms: Yup.bool().oneOf([true], formatMessage(messages.agreedToTermsError)),
                      })
                    : Yup.object().shape({
                          customerInfo: createCustomerSchema(false, false),
                          agreedToTerms: Yup.bool().oneOf([true], formatMessage(messages.agreedToTermsError)),
                          birthdate: Yup.object()
                              .minimumAge(
                                  brandConfig.minBookingAge,
                                  formatMessage(messages.minimumAgeError, { age: brandConfig.minBookingAge })
                              )
                              .shape({
                                  day: Yup.string().required(mandatoryMessage),
                                  month: Yup.string().required(mandatoryMessage),
                                  year: Yup.string().required(mandatoryMessage),
                              }),
                      })
            ),
        [brandConfig.minBookingAge, createCustomerSchema, formatMessage, mandatoryMessage]
    );
};

export default useCreateDetailsSchema;
